export const routes = Object.freeze({
  HOME: '/',
  BLOG: '/blog',
  ABOUT_US: '/sobre',
  NFE: '/emissor/nfe',
  NFCE: '/emissor/nfce',
  CTE: '/emissor/cte',
  NFSE: '/emissor/nfse',
  PDV: '/emissor/pdv',
  MDFE: '/emissor/mdfe',
  AUTH_CERTIFICATE: '/auth/login/certificate',
  AUTH_SIGNIN_OTP_CODE: '/auth/login/otp-code',
  AUTH_REGISTER: '/auth/register',
  AUTH_LOGIN: '/auth/login',
  PLATFORM: '/platform',
  PLATFORM_APPS: '/platform/apps',
  TRUTUS: '/confie',
  TRUTUS_PRIVACY: '/confie/privacidade',
  TRUTUS_TERMS: '/confie/termos-de-uso',
  WORK_WITH_US: '/trabalhe-conosco',
  PROFILE: '/platform/perfil',
  PLATFORM_TOOLS: '/platform/ferramentas',
  PLATFORM_SHOP: '/platform/shop',
  PLATFORM_BLOG: '/platform/blog',
  PLATFORM_ROADMAP: '/platform/roadmap',
  PLATFORM_TOOL_LEITOR_XML: '/platform/ferramentas/leitor-xml',
})
